import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SectionHeading from "@/components/base/SectionHeading";
import { specials } from "@/mocks/specials";
import { usePageMeta } from "@/hooks/usePageMeta";
import SpecialCard from "./components/SpecialCard";

export default function SpecialPage() {
  const [expanded, setExpanded] = useState<string | null>(specials[0]?.id ?? null);

  usePageMeta({
    title: "影视专题合集 - 棒棒TV精选主题推荐",
    description:
      "棒棒TV影视专题合集，围绕年度大片、悬疑烧脑、治愈综艺等主题，为你精心整理值得一看的影视作品清单。",
    keywords: "棒棒TV专题,影视专题,影视合集,电影合集,电视剧推荐,主题推荐",
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <section className="bg-primary-950 px-4 py-12 md:px-8 md:py-16">
          <div className="mx-auto max-w-[1180px]">
            <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-bookmark-3-line"></i>
              专题合集
            </span>
            <h1 className="mt-4 font-heading text-3xl font-black text-background-50 md:text-4xl">
              影视专题精选
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">
              我们围绕不同主题为影视作品重新编排，从年度大片到治愈综艺，从烧脑悬疑到自然纪实，帮你按兴趣快速找到一整组值得连看的好内容。
            </p>
          </div>
        </section>

        <div className="mx-auto max-w-[1180px] px-4 py-8 md:px-8 md:py-10">
          <div className="mb-8 flex flex-wrap gap-2">
            {specials.map((topic) => (
              <a
                key={topic.id}
                href={`#${topic.id}`}
                onClick={() => setExpanded(topic.id)}
                className="whitespace-nowrap rounded-full border border-background-300 px-4 py-1.5 text-xs font-medium text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
              >
                {topic.title}
              </a>
            ))}
          </div>

          {specials.length === 0 ? (
            <div className="rounded-lg border border-dashed border-background-300 py-20 text-center">
              <i className="ri-inbox-archive-line text-4xl text-foreground-300"></i>
              <p className="mt-4 text-base text-foreground-600">当前暂无专题内容</p>
            </div>
          ) : (
            <div className="space-y-8">
              {specials.map((topic, index) => (
                <div key={topic.id} id={topic.id} className="scroll-mt-24">
                  <SpecialCard
                    topic={topic}
                    index={index}
                    expanded={expanded === topic.id}
                    onToggle={() =>
                      setExpanded((prev) => (prev === topic.id ? null : topic.id))
                    }
                  />
                </div>
              ))}
            </div>
          )}

          <section className="mt-14">
            <SectionHeading title="更多精彩内容" icon="ri-compass-3-line" />
            <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
              {[
                { to: "/category/movie", label: "电影频道", icon: "ri-movie-2-line" },
                { to: "/category/tv", label: "电视剧频道", icon: "ri-tv-2-line" },
                { to: "/category/variety", label: "综艺频道", icon: "ri-mic-line" },
                { to: "/category/documentary", label: "纪录片频道", icon: "ri-earth-line" },
              ].map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-6 text-center transition-colors hover:border-accent-300 hover:bg-accent-50"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                  <span className="text-sm font-semibold text-foreground-800">{item.label}</span>
                </Link>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}